// @vendors
const { connect } = require('react-redux');
// @components
const ChatStatus = require('./ChatStatus');

const mapStateToProps = (state) => ({
    conversationStatus: state.okChat.get('conversationStatus'),
    disconnectedNotice: state.okChat.get('disconnectedNotice'),
    isChatAvailable: state.okChat.get('isChatAvailable'),
    msgReceiveFail : state.okChat.get('msgReceiveFail'),
    participantJoined: state.okChat.get('participantJoined'),
	timer: state.okChat.get('timer')
});

const ChatStatusContainer = connect(mapStateToProps, null)(ChatStatus);

module.exports = ChatStatusContainer;
